export const dashConst = {
    UPDATE: 'DASH_UPDATE',
    RESET: 'DASH_RESET'
};
